import { Suspense } from 'react'

import { CardsRedirect, type CardsRedirectProps } from '~/boundedContext/cards/components/cards-redirect'
import { ShuffledCards } from '~/boundedContext/cards/components/shuffled-cards'
import { CardsTour } from '~/boundedContext/onboarding'
import { useCardsGameStore } from '~/stores/cards-game'

type CardsProps = Pick<CardsRedirectProps, 'paths'> & {
  noTour?: boolean
}

export const Cards = ({ paths, noTour }: CardsProps) => {
  const shuffledCards = useCardsGameStore(state => state.shuffledCards)
  const activeItemIndex = useCardsGameStore(state => state.activeItemIndex)

  const activeCard = shuffledCards[activeItemIndex]

  return (
    <CardsRedirect activeCard={activeCard} paths={paths}>
      {activeCard && <ShuffledCards activeCard={activeCard} />}
      {noTour || (
        <Suspense fallback={null}>
          <CardsTour />
        </Suspense>
      )}
    </CardsRedirect>
  )
}
